<template>
	<div class="updatepwd">
		<div class="site_top">
			<h3>修改密码</h3>
			<span class="line"></span>
		</div>
		<div class="form_panel">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" size="lage" label-width="110px">
				<input type="password" hidden autocomplete="new-password" />
				<el-form-item label="手机号码" prop="phone">
					<el-input v-model="ruleForm.phone" placeholder="请输入手机号码"></el-input>
				</el-form-item>
				<el-form-item label="验证码" prop="captchaPhone">
					<div class="captchabox">
						<el-input v-model="ruleForm.captchaPhone" placeholder="请输入验证码"></el-input>
						<span class="captext" @click.stop.prevent="getCaptchaHandle">{{ showText }}</span>
					</div>
				</el-form-item>
				<el-form-item label="设置新密码" prop="password">
					<el-input type="password" name="A4" style="position: fixed; bottom: -9999999px"></el-input>
					<el-input name="A4" type="password" v-model="ruleForm.password" placeholder="请设置新密码" autocomplete="new-password" readonly onfocus="this.removeAttribute('readonly')"></el-input>
				</el-form-item>
				<el-form-item label="确认新密码" prop="comfirmPassword">
					<el-input type="password" name="A5" style="position: fixed; bottom: -9999999px"></el-input>
					<el-input type="password" name="A5" v-model="ruleForm.comfirmPassword" placeholder="请确认新密码" autocomplete="new-password" readonly onfocus="this.removeAttribute('readonly')"></el-input>
				</el-form-item>
				<el-form-item>
					<div class="btn-control">
						<el-button type="primary" round class="elbtnColor" @click="submitForm" size="medium">确认修改</el-button>
					</div>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import { isMobile } from '@/utils/validate'
import { RSAEncrypt } from '@/utils'
export default {
	data() {
		var validateMobile = (rule, value, callback) => {
			if (!isMobile(value)) {
				callback(new Error('手机号格式错误'))
			} else {
				callback()
			}
		}
		return {
			ruleForm: {
				phone: '',
				captchaPhone: '',
				password: '',
				comfirmPassword: '',
			},
			rules: {
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					//{ validator: validatePassword, trigger: "blur" },
				],
				comfirmPassword: [
					{ required: true, message: '请输入确认密码', trigger: 'blur' },
					// { validator: validateComfirmPassword, trigger: "blur" },
				],
				phone: [
					{ required: true, message: '请输入手机号码', trigger: 'blur' },
					{ validator: validateMobile, trigger: 'blur' },
				],
				captchaPhone: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
			},
			countdown: 60,
			showText: '获取验证码',
		}
	},
	methods: {
		submitForm() {
			this.$refs['ruleForm'].validate(valid => {
				if (valid) {
					if (this.ruleForm.password != this.ruleForm.comfirmPassword) {
						this.$message.warning('确认密码与密码输入不一致')
						return
					}

					let params = {
						phone: this.ruleForm.phone,
						captchaPhone: this.ruleForm.captchaPhone,
						password: RSAEncrypt(this.ruleForm.password),
					}
					this.$http.post(this.$api.userApi.updatePwd, params).then(() => {
						this.$message({
							message: '修改成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.$refs['ruleForm'].resetFields()
							},
						})
					})
				}
			})
		},
		// 获取验证码
		getCaptchaHandle() {
			if (!this.ruleForm.phone) return this.$message.warning('请输入手机号码')
			if (!isMobile(this.ruleForm.phone)) return this.$message.warning('手机号格式错误')
			if (this.countdown != 60) return
			let params = {
				phone: this.ruleForm.phone,
			}
			this.$http.post(this.$api.userApi.getpCaptcha, params).then(({ data }) => {
				console.log(data)
				this.$message.success('短信发送成功')
				this.countdown = 60
				this.settime()
			}).catch(()=>{})
		},
		settime() {
			//发送验证码倒计时
			let _this = this
			if (_this.countdown == 0) {
				_this.showText = '获取验证码'
				_this.countdown = 60
				return false
			} else {
				_this.showText = _this.countdown + 's'
				_this.countdown = _this.countdown - 1
			}
			setTimeout(function () {
				_this.settime()
			}, 1000)
		},
	},
}
</script>

<style lang="scss" scoped>
.updatepwd {
	width: 500px;
	.site_top {
		text-align: center;
		margin-bottom: 30px;
		h3 {
			font-size: 20px;
			line-height: 20px;
			margin: 0;
			padding: 0;
		}
		.line {
			display: inline-block;
			width: 24px;
			border: 1px solid #b7b7b7;
			margin-top: 10px;
		}
	}
	.form_panel {
		.title {
			padding: 6px 10px;
			margin-bottom: 25px;
			background: #f2f3f5;
		}
		.tips {
			h3 {
				line-height: 20px;
				margin: 0;
			}
		}
		.btn-control {
			text-align: center;
			margin-top: 60px;
			.elbtnColor {
				width: 100%;
			}
		}
	}
}
</style>
